"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MerchantFieldValidator = void 0;

var _Messages = require("./Messages");

var _FieldValidator = require("./FieldValidator");

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

var OK = "";
var Regex = {
  FORMATTED_PHONE_REGEX: /^[0-9-]+$/,
  PHONE_REGEX: /^\d+$/,
  LOAN_PURPOSE_REGEX: _FieldValidator.Regex.SAFE_TEXT_REGEX,
  NUMBER_REGEX: /[0-9]/,
  NUMBER_REGEX_GLOBAL: /[^0-9.]/g,
  EMAIL_REGEX: /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/
};

var _validateLoanPurpose = function _validateLoanPurpose(value) {
  if (!value) return _Messages.Messages.ENTER_LOAN_PURPOSE;
  if (value.length < 3) return _Messages.Messages.ENTER_LOAN_PURPOSE_MIN;
  if (!Regex.LOAN_PURPOSE_REGEX.test(value)) return _Messages.Messages.ENTER_LOAN_PURPOSE;
  return OK;
};

var _validateJobId = function _validateJobId(value) {
  if (!value) return OK;
  if (!Regex.LOAN_PURPOSE_REGEX.test(value)) return _Messages.Messages.ENTER_VALID_JOB_ID;
  return OK;
};

var _validateTransactionAmount = function _validateTransactionAmount(value, func, props) {
  if (!props || !props.merchant || !props.merchant.transactionLimit) {
    return OK;
  }

  var transactionLimit = props.merchant.transactionLimit;
  if (!value) return _Messages.Messages.ENTER_AMOUNT;
  var amount = Number(value.replace(Regex.NUMBER_REGEX_GLOBAL, ""));
  if (amount >= transactionLimit.min && amount <= transactionLimit.max) return OK;
  return "Should be between $" + transactionLimit.min.toCommaSeparatedMoney() + " and $" + transactionLimit.max.toCommaSeparatedMoney();
}; //Username can be a phone number or email address...


var _validateUsername = function _validateUsername(value) {
  if (!value) return _Messages.Messages.ENTER_USERNAME;

  if (Regex.FORMATTED_PHONE_REGEX.test(value)) {
    // Its a phone number
    var mobileNumber = value.replace(/-/g, "");
    if (!Regex.PHONE_REGEX.test(mobileNumber)) return _Messages.Messages.ENTER_VALID_PHONE;
    if (mobileNumber.length === 10) return OK;
    if (mobileNumber.length === 11 && mobileNumber[0] === "1") return OK;
  } else {
    // It should be a valid email...
    if (!Regex.EMAIL_REGEX.test(value)) return _Messages.Messages.ENTER_VALID_EMAIL;
    return OK;
  }

  return _Messages.Messages.ENTER_USERNAME;
};

var MerchantFieldValidator = /*#__PURE__*/function () {
  function MerchantFieldValidator(amplitude, page) {
    _classCallCheck(this, MerchantFieldValidator);

    this.amplitude = amplitude;
    this.application = "Merchant";
    this.page = page;
    this.validateMobileNumber = (0, _FieldValidator.logValidationError)(_FieldValidator.validateMobileNumber, this.application, this.page, "Mobile Number");
    this.validateEmail = (0, _FieldValidator.logValidationError)(_FieldValidator.validateEmail, this.application, this.page, "Email");
    this.validateLoanPurpose = (0, _FieldValidator.logValidationError)(_validateLoanPurpose, this.application, this.page, "Loan Purpose");
    this.validateTransactionAmount = (0, _FieldValidator.logValidationError)(_validateTransactionAmount, this.application, this.page, "Transaction Amount");
    this.validateCompletedOn = (0, _FieldValidator.logValidationError)(_FieldValidator.validateCompletedOn, this.application, this.page, "Service Completed On");
    this.validateUsername = (0, _FieldValidator.logValidationError)(_validateUsername, this.application, this.page, "Username");
    this.validateJobId = (0, _FieldValidator.logValidationError)(_validateJobId, this.application, this.page, "Job ID");
  }

  _createClass(MerchantFieldValidator, [{
    key: "log",
    value: function log(field, message) {
      (0, _FieldValidator.logValidationError)(function (props) {
        return props;
      }, this.application, this.page, field, this._props)(message);
    }
  }]);

  return MerchantFieldValidator;
}();

exports.MerchantFieldValidator = MerchantFieldValidator;